const Errors = {
  SERVER_ERROR:
    "Ocurrió un error en la petición, por favor intenta nuevamente.",
};


const IdentifierType = {
  DNI: { key: 1, label: "D.N.I." },
  CE: { key: 4, label: "CARNE DE EXTRANJERIA" },
  PASAPORTE: { key: 7, label: "PASAPORTE" },
  CARNE_REFUGIO: { key: 9, label: "CARNE DE SOLICITUD DE REFUGIO" },
  CARNE_IDENTIDAD: { key: 22, label: "CARNE DE IDENTIDAD – RR.EE." },
  CARNE_PERMANENCIA: { key: 23, label: "CARNE PERMISO TEMP. PERMANENCIA" },
  DNI_EXTRANJERO: { key: 24, label: "DOC. DE IDENTIDAD EXTRANJERO" },
  LIBRETA_MILITAR: { key: 90, label: "LIBRETA MILITAR" },
  CARNET_MILITAR: { key: 91, label: "CARNET MILITAR" },
  OTROS: { key: 0, label: "OTROS" },
};

const BooleanTypes = {
  YES: { key: 1, label: "SÍ" },
  NO: { key: 0, label: "NO" },
}

const AreaStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "success-solid", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "warning-solid", action: 'Activar' },
}

const CompanyStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "success-solid", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "warning-solid", action: 'Activar' },
}

// Tipos de contrato — Tabla 12 T-Registro (SUNAT).
// key = código que se persiste ("01".."14"). fixedTerm = lleva duración (meses) y fecha de fin.
// Los resaltados (01, 02, 03) van primero en el dropdown.
const ContractType = {
  INDETERMINADO:        { key: '01', label: '01 - A PLAZO INDETERMINADO',                              fixedTerm: false },
  TIEMPO_PARCIAL:       { key: '02', label: '02 - A TIEMPO PARCIAL',                                    fixedTerm: true },
  INICIO_INCREMENTO:    { key: '03', label: '03 - POR INICIO O INCREMENTO DE ACTIVIDAD',               fixedTerm: true },
  NECESIDADES_MERCADO:  { key: '04', label: '04 - POR NECESIDADES DEL MERCADO',                         fixedTerm: true },
  RECONVERSION:         { key: '05', label: '05 - POR RECONVERSIÓN EMPRESARIAL',                        fixedTerm: true },
  OCASIONAL:            { key: '06', label: '06 - OCASIONAL',                                           fixedTerm: true },
  SUPLENCIA:            { key: '07', label: '07 - DE SUPLENCIA',                                         fixedTerm: true },
  EMERGENCIA:           { key: '08', label: '08 - DE EMERGENCIA',                                        fixedTerm: true },
  OBRA_DETERMINADA:     { key: '09', label: '09 - PARA OBRA DETERMINADA O SERVICIO ESPECÍFICO',         fixedTerm: true },
  INTERMITENTE:         { key: '10', label: '10 - INTERMITENTE',                                         fixedTerm: true },
  TEMPORADA:            { key: '11', label: '11 - DE TEMPORADA',                                         fixedTerm: true },
  EXPORTACION_NO_TRAD:  { key: '12', label: '12 - DE EXPORTACIÓN NO TRADICIONAL',                        fixedTerm: true },
  EXTRANJERO:           { key: '13', label: '13 - DE EXTRANJERO',                                        fixedTerm: true },
  ADMIN_SERVICIOS:      { key: '14', label: '14 - ADMINISTRATIVO DE SERVICIOS',                          fixedTerm: true },
}

const PositionStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "success-solid", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "warning-solid", action: 'Activar' }
}



const PayrollTypes = {
  OPERATORS: { key: 1, label: "OPERADORES" },
  ADMINISTRATORS: { key: 2, label: "ADMINISTRATIVOS" }
}

const AccountType = {
  SAVINGS: { key: 1, label: "AHORROS" },
  CURRENT: { key: 2, label: "CORRIENTE" },
  SALARY: { key: 3, label: "SUELDO" },
}

const AuditLogAction = {
  CREATE:    { key: "CREATE",    label: "Creación",      color: "dark" },
  UPDATE:    { key: "UPDATE",    label: "Actualización", color: "warning-solid" },
  DELETE:    { key: "DELETE",    label: "Eliminación",   color: "danger-solid" },
  LOGIN:     { key: "LOGIN",     label: "Ingreso",       color: "success-solid" },
  APPROVE:   { key: "APPROVE",   label: "Aprobación",    color: "success-solid" },
  REJECT:    { key: "REJECT",    label: "Rechazo",       color: "danger-solid" },
  CANCEL:    { key: "CANCEL",    label: "Cancelación",   color: "warning-solid" },
  CALCULATE: { key: "CALCULATE", label: "Cálculo",       color: "info-solid" },
  GENERATE:  { key: "GENERATE",  label: "Generación",    color: "info-solid" },
  FINALIZE:  { key: "FINALIZE",  label: "Finalización",  color: "secondary-solid" },
  EXPORT:    { key: "EXPORT",    label: "Exportación",   color: "light" },
  PAY:          { key: "PAY",          label: "Pago",              color: "success-solid" },
  EDIT_PAYMENT: { key: "EDIT_PAYMENT", label: "Edición de pago",   color: "warning-solid" },
  ENJOY:        { key: "ENJOY",        label: "Goce",              color: "info-solid" },
  UPLOAD_PHOTO: { key: "UPLOAD_PHOTO", label: "Subida de foto",    color: "info-solid" },
  DELETE_PHOTO: { key: "DELETE_PHOTO", label: "Eliminación de foto", color: "danger-solid" },
  UPLOAD_DOCUMENT: { key: "UPLOAD_DOCUMENT", label: "Subida de documento", color: "info-solid" },
}

const AuditLogSection = {
  EMPLOYEE:      { key: "EMPLOYEE",      label: "Colaboradores" },
  CONTRACT:      { key: "CONTRACT",      label: "Contratos" },
  COMPANY:       { key: "COMPANY",       label: "Empresas" },
  AREA:          { key: "AREA",          label: "Áreas" },
  POSITION:      { key: "POSITION",      label: "Cargos" },
  VACATION:      { key: "VACATION",      label: "Vacaciones" },
  MEDICAL_LEAVE: { key: "MEDICAL_LEAVE", label: "Descansos médicos" },
  ATTENDANCE:    { key: "ATTENDANCE",    label: "Asistencia" },
  PAYROLL:       { key: "PAYROLL",       label: "Planillas" },
  MOVEMENT:      { key: "MOVEMENT",      label: "Movimientos" },
  DOCUMENT_TYPE: { key: "DOCUMENT_TYPE", label: "Tipos de documento" },
  LEAVE:         { key: "LEAVE",         label: "Licencias y permisos" },
  GRATIFICATION: { key: "GRATIFICATION", label: "Gratificaciones" },
  CTS:           { key: "CTS",           label: "CTS" },
  SEVERANCE:     { key: "SEVERANCE",     label: "Liquidaciones" },
  MAINTENANCE:   { key: "MAINTENANCE",   label: "Mantenedores" },
}

// CDEF011 §2: quién produce el documento. Solo GENERATED lleva plantilla y firmantes.
const DocumentOrigin = {
  UPLOAD:    { key: 'UPLOAD',    label: 'Lo sube el colaborador', short: 'Subido' },
  GENERATED: { key: 'GENERATED', label: 'Lo genera Crystal desde una plantilla', short: 'Generado' },
  EXTERNAL:  { key: 'EXTERNAL',  label: 'Lo emite otro sistema (solo se adjunta)', short: 'Externo' },
}

const DocumentLifecycleStage = {
  ONBOARDING:  { key: 'ONBOARDING',  label: 'Ingreso' },
  ACTIVE:      { key: 'ACTIVE',      label: 'Durante el vínculo' },
  OFFBOARDING: { key: 'OFFBOARDING', label: 'Cese' },
}

const MaritalStatus = {
  SOLTERO:     { key: 'SOLTERO',     label: 'SOLTERO' },
  CASADO:      { key: 'CASADO',      label: 'CASADO' },
  DIVORCIADO:  { key: 'DIVORCIADO',  label: 'DIVORCIADO' },
  VIUDO:       { key: 'VIUDO',       label: 'VIUDO' },
  CONVIVIENTE: { key: 'CONVIVIENTE', label: 'CONVIVIENTE' },
}

const BloodType = {
  A_POS:  { key: 'A+',  label: 'A+' },
  A_NEG:  { key: 'A-',  label: 'A-' },
  B_POS:  { key: 'B+',  label: 'B+' },
  B_NEG:  { key: 'B-',  label: 'B-' },
  AB_POS: { key: 'AB+', label: 'AB+' },
  AB_NEG: { key: 'AB-', label: 'AB-' },
  O_POS:  { key: 'O+',  label: 'O+' },
  O_NEG:  { key: 'O-',  label: 'O-' },
}

const DisabilityType = {
  FISICA:      { key: 'FISICA',      label: 'FÍSICA' },
  SENSORIAL:   { key: 'SENSORIAL',   label: 'SENSORIAL' },
  MENTAL:      { key: 'MENTAL',      label: 'MENTAL' },
  INTELECTUAL: { key: 'INTELECTUAL', label: 'INTELECTUAL' },
}

const LaborRegime = {
  GENERAL:      { key: 'GENERAL',      label: 'GENERAL' },
  MYPE_PEQUENA: { key: 'MYPE_PEQUENA', label: 'MYPE PEQUEÑA' },
  MYPE_MICRO:   { key: 'MYPE_MICRO',   label: 'MYPE MICRO' },
  AGRARIO:      { key: 'AGRARIO',      label: 'AGRARIO' },
  CONSTRUCCION: { key: 'CONSTRUCCION', label: 'CONSTRUCCIÓN' },
  HOGAR:        { key: 'HOGAR',        label: 'HOGAR' },
  // NO_CORRESPONDE: { key: 'NO_CORRESPONDE', label: 'NO CORRESPONDE' },
}

const OccupationalCategory = {
  C01: { key: '01', label: 'Ejecutivo / Director' },
  C02: { key: '02', label: 'Empleado' },
  C03: { key: '03', label: 'Obrero' },
  C04: { key: '04', label: 'Trabajador del hogar' },
  C05: { key: '05', label: 'Trabajador de confianza' },
  C06: { key: '06', label: 'Trabajador de dirección' },
  // C07: { key: '07', label: 'Locador' },
}

const WorkerType = {
  W01: { key: '01', label: 'Ejecutivo / Personal de dirección' },
  W02: { key: '02', label: 'Empleado' },
  W03: { key: '03', label: 'Obrero' },
  W04: { key: '04', label: 'Trabajador del hogar' },
  W05: { key: '05', label: 'Trabajador de construcción civil' },
  W06: { key: '06', label: 'Trabajador agrario' },
  W07: { key: '07', label: 'Artista' },
  W99: { key: '99', label: 'Otros' },
}

const SpecialSituation = {
  SINDICALIZADO:  { key: 'SINDICALIZADO',  label: 'SINDICALIZADO' },
  MADRE_GESTANTE: { key: 'MADRE_GESTANTE', label: 'MADRE GESTANTE' },
  TELETRABAJO_COMPLETO: { key: 'TELETRABAJO_COMPLETO', label: 'TELETRABAJO COMPLETO' },
  TELETRABAJO_MIXTO:    { key: 'TELETRABAJO_MIXTO',    label: 'TELETRABAJO MIXTO' },
  NINGUNA:        { key: 'NINGUNA',        label: 'NINGUNA' },
}

const EducationLevel = {
  SECUNDARIA:    { key: 'SECUNDARIA',    label: 'SECUNDARIA' },
  TECNICO:       { key: 'TECNICO',       label: 'TÉCNICO' },
  UNIVERSITARIO: { key: 'UNIVERSITARIO', label: 'UNIVERSITARIO' },
  MAESTRIA:      { key: 'MAESTRIA',      label: 'MAESTRÍA' },
  DOCTORADO:     { key: 'DOCTORADO',     label: 'DOCTORADO' },
}

const PensionSystem = {
  AFP:         { key: 'AFP',         label: 'AFP' },
  ONP:         { key: 'ONP',         label: 'ONP' },
  SIN_REGIMEN: { key: 'SIN_REGIMEN', label: 'SIN RÉGIMEN' },
  JUBILADO:    { key: 'JUBILADO',    label: 'JUBILADO' },
}

const AfpCommissionType = {
  FLUJO: { key: 'FLUJO', label: 'FLUJO' },
  MIXTA: { key: 'MIXTA', label: 'MIXTA' },
}

const FifthCategoryStatus = {
  AFECTO:    { key: 'AFECTO',    label: 'AFECTO' },
  EXONERADO: { key: 'EXONERADO', label: 'EXONERADO' },
}

const EmergencyRelationship = {
  MADRE:   { key: 'MADRE',   label: 'MADRE' },
  PADRE:   { key: 'PADRE',   label: 'PADRE' },
  CONYUGE: { key: 'CONYUGE', label: 'CÓNYUGE' },
  HERMANO: { key: 'HERMANO', label: 'HERMANO/A' },
  OTRO:    { key: 'OTRO',    label: 'OTRO' },
}

const SalaryCurrency = {
  PEN: { key: 'PEN', label: 'PEN - Soles' },
  USD: { key: 'USD', label: 'USD - Dólares' },
}

const WorkSchedule = {
  COMPLETA: { key: 'COMPLETA', label: 'COMPLETA' },
  PARCIAL:  { key: 'PARCIAL',  label: 'PARCIAL' },
  NOCTURNA: { key: 'NOCTURNA', label: 'NOCTURNA' },
}

const VacationRequestStatus = {
  PENDIENTE: { key: 'PENDIENTE', label: 'PENDIENTE',  color: 'warning-solid' },
  APROBADA:  { key: 'APROBADA',  label: 'APROBADA',   color: 'success-solid'  },
  GOZADA:    { key: 'GOZADA',    label: 'GOZADA',     color: 'purple' },
  RECHAZADA: { key: 'RECHAZADA', label: 'RECHAZADA',  color: 'danger-solid' },
  CANCELADA: { key: 'CANCELADA', label: 'CANCELADA',  color: 'dark'   },
}

const VacationPeriodStatus = {
  VIGENTE:    { key: 'VIGENTE',    label: 'VIGENTE',    color: 'success-solid'  },
  POR_VENCER: { key: 'POR_VENCER', label: 'POR VENCER', color: 'warning-solid' },
  VENCIDO:    { key: 'VENCIDO',    label: 'VENCIDO',    color: 'danger-solid' },
  GOZADO:     { key: 'GOZADO',     label: 'GOZADO',     color: 'info-solid'   },
  // Período invalidado por cambio de fecha de ingreso: historia congelada, no seleccionable (badge gris).
  CANCELADO:  { key: 'CANCELADO',  label: 'CANCELADO',  color: 'secondary-solid' },
}

const WorkSiteStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
}

const DocumentTypeStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
}

const MedicalLeaveType = {
  ENFERMEDAD:        { key: 'ENFERMEDAD',        label: 'Enfermedad',        color: 'warning-solid' },
  ACCIDENTE_COMUN:   { key: 'ACCIDENTE_COMUN',   label: 'Accidente Común',   color: 'danger-solid'  },
  ACCIDENTE_LABORAL: { key: 'ACCIDENTE_LABORAL', label: 'Accidente Laboral', color: 'danger-solid'  },
  MATERNIDAD:        { key: 'MATERNIDAD',        label: 'Maternidad',        color: 'info-solid'    },
}

const MedicalLeaveStatus = {
  ACTIVO:     { key: 'ACTIVO',     label: 'ACTIVO',     color: 'success-solid' },
  FINALIZADO: { key: 'FINALIZADO', label: 'FINALIZADO', color: 'info-solid'  },
  CANCELADO:  { key: 'CANCELADO',  label: 'CANCELADO',  color: 'dark'  },
}

const MedicalLeaveCaseStatus = {
  DESCANSO_MEDICO: { key: 'DESCANSO_MEDICO', label: 'Descanso médico', color: 'secondary-solid' },
  SUBSIDIO:        { key: 'SUBSIDIO',        label: 'Subsidio EsSalud', color: 'warning-solid'  },
}

const MedicalLeaveProcessStatus = {
  PENDIENTE:  { key: 'PENDIENTE',  label: 'Pendiente',  color: 'danger-solid'  },
  EN_TRAMITE: { key: 'EN_TRAMITE', label: 'En trámite', color: 'warning-solid' },
  COBRADO:    { key: 'COBRADO',    label: 'Cobrado',    color: 'success-solid' },
}

const MedicalLeaveInsuranceType = {
  PARTICULAR: { key: 'PARTICULAR', label: 'Particular' },
  ESSALUD:    { key: 'ESSALUD',    label: 'EsSalud'    },
}

// Tipo de atención del descanso médico (controla campos visibles del formulario)
const MedicalLeaveCareType = {
  ESSALUD:    { key: 'ESSALUD',    label: 'EsSalud'    },
  PARTICULAR: { key: 'PARTICULAR', label: 'Particular' },
}

const PensionEntityType = {
  AFP: { key: 'AFP', label: 'AFP' },
  ONP: { key: 'ONP', label: 'ONP' },
}

const PensionEntityStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
}

const BankStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
}

const PayrollConceptType = {
  DESCUENTO: { key: 'DESCUENTO', label: 'Descuento' },
  ADICIONAL:  { key: 'ADICIONAL',  label: 'Adicional'  },
}

const PayrollConceptNature = {
  REMUNERATIVO:    { key: 'REMUNERATIVO',    label: 'Remunerativo'    },
  NO_REMUNERATIVO: { key: 'NO_REMUNERATIVO', label: 'No remunerativo' },
  NA:              { key: 'NA',              label: 'N/A'             },
}

const PayrollConceptStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
}

const PayrollMovementStatus = {
  PENDIENTE: { key: 'PENDIENTE', label: 'PENDIENTE', color: 'warning-solid' },
  PROCESADO: { key: 'PROCESADO', label: 'PROCESADO', color: 'success-solid'  },
  CANCELADO: { key: 'CANCELADO', label: 'CANCELADO', color: 'dark'   },
}

const PayrollMovementOrigin = {
  MANUAL:     { key: 'MANUAL',     label: 'Manual'    },
  ASISTENCIA: { key: 'ASISTENCIA', label: 'Asistencia' },
  PRESTAMO:   { key: 'PRESTAMO',   label: 'Préstamo'  },
  CUOTA:      { key: 'CUOTA',      label: 'Cuota'     },
}


const VoucherType = {
  RECIBO:       { key: 'RECIBO',       label: 'Recibo'          },
  FACTURA:      { key: 'FACTURA',      label: 'Factura'         },
  BOLETA:       { key: 'BOLETA',       label: 'Boleta'          },
  NOTA_CREDITO: { key: 'NOTA_CREDITO', label: 'Nota de crédito' },
  OTRO:         { key: 'OTRO',         label: 'Otro'            },
}

const InstallmentGroupStatus = {
  EN_CURSO:   { key: 'EN_CURSO',   label: 'En curso',   color: 'warning-solid' },
  COMPLETADO: { key: 'COMPLETADO', label: 'Completado', color: 'success-solid'  },
  CANCELADO:  { key: 'CANCELADO',  label: 'Cancelado',  color: 'dark'   },
}

const AttendanceStatus = {
  ASISTIO:             { key: 'ASISTIO',             label: 'Asistió',             color: '#28a745', letter: 'A'  },
  FALTA_JUSTIFICADA:   { key: 'FALTA_JUSTIFICADA',   label: 'Falta justificada',   color: '#17a2b8', letter: 'FJ' },
  FALTA_INJUSTIFICADA: { key: 'FALTA_INJUSTIFICADA', label: 'Falta injustificada', color: '#dc3545', letter: 'F'  },
  VACACIONES:          { key: 'VACACIONES',          label: 'Vacaciones',          color: '#007bff', letter: 'V'  },
  DESCANSO_MEDICO:     { key: 'DESCANSO_MEDICO',     label: 'Descanso médico',     color: '#fd7e14', letter: 'DM' },
  FERIADO:             { key: 'FERIADO',             label: 'Feriado',             color: '#6f42c1', letter: 'FE' },
  DESCANSO:            { key: 'DESCANSO',            label: 'Descanso',            color: '#adb5bd', letter: 'D'  },
  PERMISO:             { key: 'PERMISO',             label: 'Permiso',             color: '#e83e8c', letter: 'P'  },
  LICENCIA_CON_GOCE:   { key: 'LICENCIA_CON_GOCE',   label: 'Licencia con goce',   color: '#20c997', letter: 'LC' },
  LICENCIA_SIN_GOCE:   { key: 'LICENCIA_SIN_GOCE',   label: 'Licencia sin goce',   color: '#795548', letter: 'LS' },
}

const RelationshipType = {
  HIJO:        { key: 'HIJO',        label: 'Hijo(a)' },
  CONYUGE:     { key: 'CONYUGE',     label: 'Cónyuge' },
  CONVIVIENTE: { key: 'CONVIVIENTE', label: 'Conviviente' },
  PADRE:       { key: 'PADRE',       label: 'Padre' },
  MADRE:       { key: 'MADRE',       label: 'Madre' },
}

const FamilyAllowanceStatus = {
  CALIFICA:               { key: 'CALIFICA',               label: 'Califica',               color: 'success-solid' },
  NO_CALIFICA:            { key: 'NO_CALIFICA',            label: 'No califica',            color: 'danger-solid'  },
  CONSTANCIA_POR_VENCER:  { key: 'CONSTANCIA_POR_VENCER',  label: 'Constancia por vencer',  color: 'warning-solid' },
}

// key en string (no 0/1): el menú wz-filter-menu inicializa con `valor || ""`,
// y una key numérica 0 (SUSPENDIDO) se perdería por ser falsy. El status real
// en BD sigue siendo tinyint 0/1; el mapeo numérico vive en PayrollTypeList.
const PayrollTypeStatus = {
  ACTIVE:   { key: 'ACTIVO',     label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
  INACTIVE: { key: 'SUSPENDIDO', label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
}

const WorkScheduleStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
}

const PayrollFrequency = {
  WEEKLY:   { key: 'WEEKLY',   label: 'Semanal'    },
  BIWEEKLY: { key: 'BIWEEKLY', label: 'Quincenal'  },
  MONTHLY:  { key: 'MONTHLY',  label: 'Mensual'    },
}

const PayrollTaxCategory = {
  FIFTH:  { key: 'FIFTH',  label: 'Renta de 5ta categoría' },
  FOURTH: { key: 'FOURTH', label: 'Renta de 4ta categoría' },
}

const PayrollCalculationMode = {
  AUTOCALCULATED: { key: 'AUTOCALCULATED', label: 'Autocalculada según sueldo' },
  FIXED:          { key: 'FIXED',          label: 'Monto fijo por colaborador' },
  BY_INSERTION:   { key: 'BY_INSERTION',   label: 'Ingreso manual de datos' },
}

const Currencies = { PEN: 'S/' };

// Regla de continuidad de antigüedad al renovar un contrato vencido (espejo del backend
// EmploymentPeriodService.MAX_RENEWAL_GAP_DAYS): con motivo "07" y reingreso dentro de esta
// ventana en días calendario se mantiene la antigüedad; fuera de ella el período se reinicia.
const RenewalRules = { CONTINUITY_MAX_GAP_DAYS: 45 };

// Los valores deben ser los strings que compara el menú wz-filter-menu de wizeui
// (selectedCategory.type === 'SINGLE' | 'MULTIPLE' | 'DATE'); con números el panel
// de opciones queda vacío. Los consumers comparan opt.type === TypeFilters.X, así
// que siguen siendo consistentes.
const TypeFilters = { SINGLE: 'SINGLE', MULTIPLE: 'MULTIPLE', DATE: 'DATE' };

// ── Licencias y permisos ────────────────────────────────────────────────
const LeaveStatus = {
  REGISTRADA: { key: 'REGISTRADA', label: 'Registrada', color: 'secondary-solid' },
  EN_CURSO:   { key: 'EN_CURSO',   label: 'En curso',   color: 'success-solid'  },
  FINALIZADA: { key: 'FINALIZADA', label: 'Finalizada', color: 'info-solid'     },
  CANCELADA:  { key: 'CANCELADA',  label: 'Cancelada',  color: 'dark'           },
}

const LeavePaternitySubtype = {
  NORMAL:               { key: 'NORMAL',               label: 'Normal',                 days: 10 },
  PREMATURO:            { key: 'PREMATURO',            label: 'Prematuro / múltiple',   days: 20 },
  ENFERMEDAD_CONGENITA: { key: 'ENFERMEDAD_CONGENITA', label: 'Enfermedad congénita',   days: 30 },
  COMPLICACIONES_MADRE: { key: 'COMPLICACIONES_MADRE', label: 'Complicaciones madre',   days: 30 },
}

const LeaveRelationship = {
  CONYUGE: { key: 'CONYUGE', label: 'Cónyuge' },
  PADRE:   { key: 'PADRE',   label: 'Padre'   },
  MADRE:   { key: 'MADRE',   label: 'Madre'   },
  HIJO:    { key: 'HIJO',    label: 'Hijo/a'  },
  HERMANO: { key: 'HERMANO', label: 'Hermano/a' },
}

const LeaveEventLocation = {
  MISMA_LOCALIDAD: { key: 'MISMA_LOCALIDAD', label: 'Misma localidad' },
  OTRA_LOCALIDAD:  { key: 'OTRA_LOCALIDAD',  label: 'Otra localidad'  },
}

// Códigos de tipos legales (alinea con el seed del backend)
const LeaveTypeCode = {
  PATERNIDAD: 'PATERNIDAD',
  FALLECIMIENTO: 'FALLECIMIENTO',
  ENFERMEDAD_GRAVE_FAMILIAR: 'ENFERMEDAD_GRAVE_FAMILIAR',
  EXAMENES_ONCOLOGICOS: 'EXAMENES_ONCOLOGICOS',
  CANCER_MAMA_CUELLO_UTERINO: 'CANCER_MAMA_CUELLO_UTERINO',
}

// ── Gratificaciones ─────────────────────────────────────────────────────
const GratificationPeriodType = {
  JULIO:     { key: 'JULIO',     label: 'Julio — Fiestas Patrias' },
  DICIEMBRE: { key: 'DICIEMBRE', label: 'Diciembre — Navidad'     },
}

const GratificationStatus = {
  BORRADOR:   { key: 'BORRADOR',   label: 'Borrador',   color: 'warning-solid' },
  CONFIRMADO: { key: 'CONFIRMADO', label: 'Confirmado', color: 'success-solid' },
}

// ── CTS ─────────────────────────────────────────────────────────────────
const CtsPeriodType = {
  MAYO:      { key: 'MAYO',      label: 'Mayo — Semestre Nov-Abr'     },
  NOVIEMBRE: { key: 'NOVIEMBRE', label: 'Noviembre — Semestre May-Oct' },
}

const CtsStatus = {
  BORRADOR:   { key: 'BORRADOR',   label: 'Borrador',   color: 'warning-solid' },
  CONFIRMADO: { key: 'CONFIRMADO', label: 'Confirmado', color: 'success-solid' },
}

export default {
  Errors,
  Currencies,
  RenewalRules,
  LeaveStatus,
  LeavePaternitySubtype,
  LeaveRelationship,
  LeaveEventLocation,
  LeaveTypeCode,
  TypeFilters,
  IdentifierType,
  BooleanTypes,
  AreaStatus,
  CompanyStatus,
  ContractType,
  PositionStatus,
  PayrollTypes,
  AccountType,
  AuditLogAction,
  AuditLogSection,
  DocumentOrigin,
  DocumentLifecycleStage,
  MaritalStatus,
  BloodType,
  DisabilityType,
  LaborRegime,
  OccupationalCategory,
  WorkerType,
  SpecialSituation,
  EducationLevel,
  PensionSystem,
  AfpCommissionType,
  FifthCategoryStatus,
  EmergencyRelationship,
  SalaryCurrency,
  WorkSchedule,
  VacationRequestStatus,
  VacationPeriodStatus,
  PensionEntityType,
  PensionEntityStatus,
  WorkSiteStatus,
  DocumentTypeStatus,
  MedicalLeaveType,
  BankStatus,
  PayrollConceptType,
  PayrollConceptNature,
  PayrollConceptStatus,
  PayrollMovementStatus,
  PayrollMovementOrigin,
  AttendanceStatus,
  MedicalLeaveStatus,
  MedicalLeaveCaseStatus,
  MedicalLeaveProcessStatus,
  MedicalLeaveInsuranceType,
  MedicalLeaveCareType,
  VoucherType,
  InstallmentGroupStatus,
  RelationshipType,
  FamilyAllowanceStatus,
  ChannelStatus: {
    ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
    INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
  },
  ExpenseLineStatus: {
    ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'success-solid',  action: 'Suspender' },
    INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'warning-solid', action: 'Activar'   },
  },
  PayrollTypeStatus,
  PayrollFrequency,
  PayrollTaxCategory,
  PayrollCalculationMode,
  WorkScheduleStatus,
  GratificationPeriodType,
  GratificationStatus,
  CtsPeriodType,
  CtsStatus,
};
